module.exports = __webpack_public_path__ + "img/hoslogo10.aab01fb0.png";